import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Form,
  Label,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
} from "reactstrap"

import Select from "react-select"
import SimpleBar from "simplebar-react"

//i18n
import _ from "lodash"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { withTranslation } from "react-i18next"
import { getFilters } from "services/dashboard/calls"
import { useIndicadoresFiltrosStore } from "store/useIndicadoresFiltrosStore"

const OffCanvasFilter = ({ showFilter, setShowFilter, t }) => {
  const filtrosSelecionados = useIndicadoresFiltrosStore(
    state => state.filtrosSelecionados
  )
  const setFiltro = useIndicadoresFiltrosStore(state => state.setFiltro)
  const limparFiltros = useIndicadoresFiltrosStore(state => state.limparFiltros)
  const setFetchReports = useIndicadoresFiltrosStore(
    state => state.setFetchReports
  )

  const [filterOptions, setFilterOptions] = useState({
    product: [],
    uf: [],
    factories: [],
    courrier: [],
  })

  const [isLoading, setIsLoading] = useState(false)

  const fetchFilters = async () => {
    try {
      const { payload } = await getFilters()
      setFilterOptions({
        ...payload,
        uf: payload?.uf?.sort((a, b) => a.value.localeCompare(b.value)),
      })
      setFetchReports()
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    setIsLoading(true)
    fetchFilters()
  }, [])

  const onQuery = e => {
    e.preventDefault()
    setFetchReports()
    setShowFilter(!showFilter)
  }

  return (
    <Offcanvas
      isOpen={showFilter}
      scrollable
      direction="end"
      toggle={() => {
        setShowFilter(!showFilter)
      }}
      style={{ width: "30%" }}
      className="bg-secondary"
    >
      <OffcanvasHeader
        toggle={() => {
          setShowFilter(!showFilter)
        }}
        className="text-white"
      >
        {t("Filtro")}
      </OffcanvasHeader>
      <SimpleBar className="h-100">
        <OffcanvasBody>
          <Form className="form-horizontal" onSubmit={onQuery}>
            <Row>
              <Col>
                <Card className="border mb-2 bg-primary" color="primary">
                  <CardBody>
                    <Row>
                      <Col lg={6}>
                        <Row controlid="filterStart">
                          <Label>{t("Início")}</Label>
                          <DatePicker
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            selected={filtrosSelecionados.startAt}
                            selectsStart
                            startDate={filtrosSelecionados.startAt}
                            endDate={filtrosSelecionados.endAt}
                            onChange={e => {
                              setFiltro("startAt", e)
                            }}
                          />
                        </Row>
                      </Col>
                      <Col lg={6}>
                        <Row controlid="filterEnd">
                          <Label>{t("Fim")}</Label>
                          <DatePicker
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            selected={filtrosSelecionados.endAt}
                            selectsEnd
                            startDate={filtrosSelecionados.startAt}
                            endDate={filtrosSelecionados.endAt}
                            onChange={e => {
                              setFiltro("endAt", e)
                            }}
                          />
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card className="border mb-2 bg-primary" color="primary">
                  <CardBody>
                    <Row controlid="factoriesRef">
                      <Label>{t("Fábrica")}</Label>
                      <Select
                        classNamePrefix="reactSelect"
                        isMulti
                        options={filterOptions.factories}
                        placeholder={t("Selecione uma Fábrica")}
                        value={filtrosSelecionados.factories}
                        onChange={e => {
                          setFiltro("factories", e)
                        }}
                      />
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card className="border mb-2 bg-primary" color="primary">
                  <CardBody>
                    <Row controlid="produtoRef">
                      <Label>{t("Produto")}</Label>
                      <Select
                        classNamePrefix="reactSelect"
                        isMulti
                        options={filterOptions.product}
                        placeholder={t("Selecione um Produto")}
                        value={filtrosSelecionados.product}
                        onChange={e => {
                          setFiltro("product", e)
                        }}
                      />
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card className="border mb-2 bg-primary" color="primary">
                  <CardBody>
                    <Row controlid="ufRef">
                      <Label>{t("UF")}</Label>
                      <Select
                        classNamePrefix="reactSelect"
                        isMulti
                        options={filterOptions.uf}
                        placeholder={t("Selecione uma UF")}
                        value={filtrosSelecionados.uf}
                        onChange={e => {
                          setFiltro("uf", e)
                        }}
                        menuPlacement="top"
                      />
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card className="border mb-2 bg-primary" color="primary">
                  <CardBody>
                    <Row controlid="courrierRef">
                      <Label>{t("Transpordarora")}</Label>
                      <Select
                        classNamePrefix="reactSelect"
                        isMulti
                        options={filterOptions.courrier}
                        placeholder={t("Selecione uma Transpordarora")}
                        value={filtrosSelecionados.courrier}
                        onChange={e => {
                          setFiltro("courrier", e)
                        }}
                        menuPlacement="top"
                      />
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col sm={10}>
                <div>
                  <button
                    className="btn btn-primary btn-block"
                    type="submit"
                    style={{
                      width: "100%",
                      display: "block",
                      marginBottom: 60,
                    }}
                    disabled={isLoading}
                  >
                    {t("Filtrar")}
                  </button>
                </div>
              </Col>
              <Col>
                <div>
                  <button
                    className="btn btn-danger btn-block"
                    style={{
                      width: "100%",
                      display: "block",
                      marginBottom: 60,
                    }}
                    onClick={e => {
                      e.preventDefault()

                      limparFiltros()
                    }}
                  >
                    {t("X")}
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
        </OffcanvasBody>
      </SimpleBar>
    </Offcanvas>
  )
}

OffCanvasFilter.propTypes = {
  reRender: PropTypes.bool,
  setReRender: PropTypes.func,
  showFilter: PropTypes.bool,
  setShowFilter: PropTypes.func,
}

export default withTranslation()(OffCanvasFilter)
